export enum ConsumerType {
  Goldcast = 'goldcast',
  Cvent = 'cvent'
}
